import { useApplicationStore } from "@/stores/Application";
import { ref, type Ref, getCurrentInstance, computed } from 'vue';
import { storeToRefs } from 'pinia';

export const useFocusedComponents = (name: string) => {
    const ApplicationStore = useApplicationStore();
    const {
        getFocusedElements
    } = storeToRefs(ApplicationStore);
    const { addFocusedElement, removeFocusedElement } = ApplicationStore;

    const instance = getCurrentInstance()
    const outerElementRef: Ref<HTMLElement | null > = ref(null)
    const outerElement = computed(() => instance?.proxy?.$el ?? outerElementRef.value);

    const setFocused = (): void => {
        if (!name) {
            return;
        }
        addFocusedElement(name);
        if (outerElement.value) {
            outerElement.value.classList.add("is-focused");
        }
    };
    const unsetFocused = (): void => {
        if (!name) {
          return;
        }
        removeFocusedElement(name);
        if (outerElement.value) {
            outerElement.value.classList.remove("is-focused");
        }
    };
    const isFocused = (): boolean => {
        if (!name) {
            return false;
        }
        const list = getFocusedElements.value;
        return list.has(name);
    };

    return {
        outerElementRef,
        setFocused,
        unsetFocused,
        isFocused
    }
}